
import { useToast } from "@/hooks/use-toast";

interface ShareData {
  title: string;
  text?: string;
  url: string;
}

export const useShare = () => {
  const { toast } = useToast();

  const share = async (data: ShareData) => {
    // Check if Web Share API is available (mainly on mobile)
    if (navigator.share) {
      try {
        await navigator.share(data);
        toast({
          title: "Shared successfully",
          description: "Content has been shared successfully.",
        });
      } catch (error) {
        // User cancelled or sharing failed
        if ((error as Error).name !== 'AbortError') {
          console.error('Error sharing:', error);
          fallbackShare(data.url);
        }
      }
    } else {
      // Fallback to copying URL to clipboard
      fallbackShare(data.url);
    }
  };

  const fallbackShare = async (url: string) => {
    try {
      await navigator.clipboard.writeText(url);
      toast({
        title: "Link copied",
        description: "Provider link has been copied to clipboard.",
      });
    } catch (error) {
      console.error('Error copying to clipboard:', error);
      toast({
        title: "Error",
        description: "Unable to copy link. Please copy the URL manually.",
        variant: "destructive",
      });
    }
  };

  return { share };
};
